/**
 * @file  list/index.tsx
 * @description  ul li core element
 *
 * @author ogarcia (ozkary)
 *
 */
import React from 'react';
import * as S from './styles';

/**
 * @description list styled element
 *
 * @param ButtonProps
 */
const List = ({ items, className }: S.Props): JSX.Element => (
  <S.List
    dataSource={items}
    className={className}
    renderItem={(item) => (
      <S.List.Item>
        <S.Typography.Text> {item}</S.Typography.Text>
      </S.List.Item>
    )}
  />
);

export default List;
